<script>
    import { flow_steps, emitter, dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip, isEmptyOrSpaces, cleanCurrency, userNotification } from './stores.js';
    import * as yup from 'yup'; 
    import Cleave from 'cleave.js';    
    import { onMount } from "svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Dtemplate from "./components/detailedtemplate.svelte";
    import Overlay from "./components/overlaycomponent.svelte";
    import { push } from 'svelte-spa-router';
    import AddressComponent from './components/addresscomponent.svelte';

    let is_military;

    let first_name_element;
    let last_name_element;
    let mobile_phone_element;
    let email_element;
    let address_element;
    let user_address;
    let city_element;
    let zipcode_element;
    let state_element;

    let mobile_phone_formatter;
    let show_overlay = false;
    let progress_text_element;

    // setTimeout(() => {
    //     showProgress();
    // }, 100);

    function showText(the_text){
        // progress_text_element.classList.remove("shown");
        progress_text_element.classList.add("hidden");
        setTimeout(() => {
            progress_text_element.innerHTML = the_text;
            progress_text_element.classList.remove("hidden");
        }, 1000);
        // progress_text_element.classList.add("shown");
            

    }
    let step1, step2;
    function showProgress() {
        NProgress.start();


        // show_overlay = true;
        // step1 = setTimeout(() => {
        //     showText("...saving your information.");
        // }, 1000);
        // step2 = setTimeout(() => {
        //     showText("...dispatching to our representatives.");
        // }, 4000);
        // setTimeout(() => {
        //     showText("...You're all set!");            
        // }, 6000);
        // setTimeout(() => {
        //     showText("...we'll be in touch shortly.");
        // }, 2000 + 6000);
        // setTimeout(() => {
        //     show_overlay = false;
        // }, 4000+6000);

    }

    function doSaveInfo(search_data, callback){
        if($flow_steps.current_flow.startsWith("i")) {
            search_data["cid"] = "219";
        }else{
            search_data["cid"] = "222";
        }
        showProgress();
        superagent
        .post('/api/obapi')
        .send({ action: 'addlead', search_data: search_data }) // sends a JSON post body
        .set('accept', 'json')
        .end((err, res) => {
            if(err !== null){
                userNotification('error', 'Error:', err.toString());
                show_overlay = false;
                NProgress.done();
            }else{
// console.log(res.text)
                res = JSON.parse(res.text);
                if(!res.st){
                    userNotification('error', 'Error:', res.msg);
                    show_overlay = false;
                    NProgress.done();

                }else{
                    clearTimeout(step1);
                    clearTimeout(step2);
                    showText("...You're all set!");
                    setTimeout(() => {
                        showText("...we'll be in touch shortly.");
                    }, 2000);
                    setTimeout(() => {
                        show_overlay = false;
                        NProgress.done();
                        // callback();
                        push('#/dfp_thank_you');
                        // $emitter.emit('progressClick', '');
                    }, 4000);

                }
            }
        });        

    }

    function doBookAppointment(callback) {
        console.log("... booking appointment");
        // console.log($user_data);
        let tobj = {};
        tobj['first_name'] = $user_data['firstname'];
        tobj['last_name'] = $user_data['lastname'];
        tobj['email'] = $user_data['email'];
        tobj['phone_number'] = $user_data['mobilephone'];
        tobj['best_contact_method'] = $user_data['bestcontactmethod'];
        tobj['best_time'] = $user_data['bestcontacttime'];
        tobj['credit_score'] = $user_data['creditscore'];
        tobj['credit_fico'] = $user_data['creditscore'];

        tobj['street_address_looking'] = `${$user_data['propertyaddress']}${(!isEmptyOrSpaces($user_data['propertyaptunit'])) ? ' (' + $user_data['propertyaptunit'] + ')' : ''}`;
        tobj['city_looking'] = $user_data['propertycity'];
        tobj['state_purchasing_looking'] = $user_data['propertystate'];
        tobj['zip_code_text_looking'] = $user_data['propertyzipcode'];
        tobj['property_zip'] = $user_data['propertyzipcode'];


        tobj['property_use'] = $user_data['hometype'];

        tobj['property_value'] = cleanCurrency($user_data['propertyvalue']);
        if(!isEmptyOrSpaces($user_data['purchaseprice'])){
            // tobj['property_value'] = cleanCurrency($user_data['purchaseprice']);
            tobj['spend_dollars_text'] = cleanCurrency($user_data['purchaseprice']);
        }

        tobj['remaining_mortgage'] = cleanCurrency($user_data['currentbalance']);

        tobj['street_address'] = `${user_address.address}${(!isEmptyOrSpaces($user_data['currentaptunit'])) ? ' (' + $user_data['currentaptunit'] + ')' : ''}`;
        tobj['city'] = $user_data['currentcity'];
        tobj['state'] = $user_data['currentstate'];
        tobj['zip_code'] = $user_data['currentzipcode'];

        if($user_data['loantype'] === "Purchase"){
            tobj['application'] = "Purchase";
            const pprice = parseFloat($user_data['purchaseprice'].toString().replace(/[^\d.-]/g, '').trim());
            const dpmt = parseFloat($user_data['downpaymentamount'].toString().replace(/[^\d.-]/g, '').trim());
            const tot = Math.round(pprice - dpmt);
            tobj['loan_amount'] = tot.toLocaleString('en-US', {style: 'currency', currency: 'USD'});

        }else{
            tobj['application'] = "Refinance";
            const pprice = parseFloat($user_data['currentbalance'].toString().replace(/[^\d.-]/g, '').trim());
            const coamount = parseFloat($user_data['cashoutamount'].toString().replace(/[^\d.-]/g, '').trim());
            const tot = Math.round(pprice + coamount);
            tobj['loan_amount'] = tot.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
        }

        tobj['military_qualifier'] = ($user_data['military']) ? "Yes" : "No";
        tobj['first_time_home_buyer'] = ($user_data['firsttimebuyer']) ? "Yes" : "No";


        // tobj['signed_agreement'] = ($user_data['whereinprocess'] === "I have signed a purchase contract") ? "Yes" : "No";
        tobj['signed_agreement'] = ($user_data['whereinprocess'] === "I have signed a purchase contract");

        tobj['down_payment_no_home'] = $user_data['downpaymentamount'];
        tobj['down_payment_no_home_percent'] = $user_data['downpaymentpercentage'];


        tobj['county_looking'] = $user_data['propertycounty'];
        // tobj['has_realtor'] = ($user_data['workingwithrealtor']) ? "Yes" : "No";
        tobj['has_realtor'] = $user_data['workingwithrealtor'];
        tobj['refinance_reason'] = $user_data['refigoal'];
        
        if($user_data['selected_product'] !== null){
            tobj['interest_rate'] = $user_data['selected_product']['rate'];
            tobj['loan_type'] = $user_data['selected_product']['loanType'];
        }

        tobj['property_type'] = $user_data['propertytype'];

        
        // 
        


        console.log(tobj);
        doSaveInfo(tobj, callback);



    }


    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

    const formSchema = yup.object().shape({
        first_name_element: yup
        .string()
        .required('First Name required to find the best rates.'),
        last_name_element: yup
        .string()
        .required('Last Name required to find the best rates.'),
        mobile_phone_element: yup
        .string()
        .required('Phone number required to find the best rates.')
        .matches(phoneRegExp, "A valid phone number required to find the best rates."),
        email_element: yup
        .string()
        .required('Email required to find the best rates.')
        .email('A valid email is required to find the best rates.'),
        // address_element: yup
        // .string()
        // .required('Address required to find the best rates.'),
        city_element: yup
        .string()
        .required('City or town required to find the best rates.'),
        zipcode_element: yup
        .string()
        .required('Zip code required to find the best rates.'),
        state_element: yup
        .string()
        .required('State required to find the best rates.'),
    });

    async function checkNext() {
        clearAllInvalidItems();
        let res = false;
        await formSchema.validate({ 
            first_name_element: first_name_element.value.trim(),
            last_name_element: last_name_element.value.trim(),
            mobile_phone_element: mobile_phone_element.value.replace(/[^\d.-]/g, '').trim(),
            email_element: email_element.value.trim(),
            // address_element: address_element.value.trim(),
            city_element: city_element.value.trim(),
            zipcode_element: zipcode_element.value.trim(),
            state_element: state_element.value.trim(),
        }).then(function (value) {
            res = true;
        }).catch(function (err) {
            console.log(err);
                invalidateItem(eval(err.path), err.errors[0]);
            res = false;
        });

        return res;
    }

    function clearFunction() {
        dbClearAllInvalidItems();
    }

    function doSelectAddress(){
        console.log(user_address);
        zipcode_element.value = user_address.zipcode;
        city_element.value = user_address.city;
        state_element.value = user_address.state;
        // address_element.value = user_address.address;
        // $user_data.currentaddress = user_address.address;
        setTimeout(() => {
            // $user_data['currentaddress'] = user_address.address;
        }, 100);
    }

    onMount(async() => {
        if($user_data.military){
            is_military = "Yes";
        }else{
            is_military = "No";
        }

        mobile_phone_formatter = new Cleave(mobile_phone_element, {
            numericOnly: true,
            blocks: [0, 3, 0, 3, 4],
            delimiters: ["(", ")", " ", "-"]
        });

    });

    $: {
        if(is_military !== undefined){
            if(is_military === "Yes"){
                $user_data.military = true;
            }else{
                $user_data.military = false;
            }
        }
    }

</script>
<Overlay bind:shown={show_overlay} >
    <div class="busybox">
        <div class="busyboxindicatorcontainer">
            <img alt="searching rates" src="/img/ballbarprog.gif" />
        </div>    
        <div bind:this={progress_text_element} class="progresstextholder hidden">
        </div>

    </div>
</Overlay>

<Dtemplate
progress_mobile_version={true}
>

    <Progresscomponent 
    show_progress_ring={false}
    pre_next_callback_function={checkNext}
    next_function={doBookAppointment}
    title=""
    >
    <div class="formcontainer">
        <div class="titlecontainer">Tell us about yourself</div>
        <div class="copycontainer">We will use this information to review the details of your home and reach out at a time that's convenient for you.</div>
        <div class="sectionheader">Personal Information</div>
        <div class="formrow">
            <div class="formrowlabel">First name</div>
            <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={first_name_element} bind:value={$user_data.firstname} type="text" /></div>
        </div>
        <div class="formrow">
            <div class="formrowlabel">Last name</div>
            <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={last_name_element} bind:value={$user_data.lastname} type="text" /></div>
        </div>
        <div class="multipleformrow">
            <div class="formrow">
                <div class="formrowlabel">Mobile phone</div>
                <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={mobile_phone_element} bind:value={$user_data.mobilephone} type="text" /></div>
            </div>
            <div class="formrow">
                <div class="formrowlabel">Email</div>
                <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={email_element} bind:value={$user_data.email} type="text" /></div>
            </div>
        </div>
        <div class="multipleformrow">
            <div class="formrow">
                <div class="formrowlabel">Best contact method</div>
                <div class="formrowinput"><select bind:value={$user_data.bestcontactmethod}><option>Email</option><option>Phone</option></select></div>
            </div>
            <div class="formrow">
                <div class="formrowlabel">Best time to contact</div>
                <div class="formrowinput"><select bind:value={$user_data.bestcontacttime}><option>Afternoon</option><option>Morning</option><option>Evening</option></select></div>
            </div>
        </div>
        <div class="formrow">
            <div class="formrowlabel">Are you, or your spouse a military veteran or actively serving?</div>
            <div class="formrowinput"><select bind:value={$user_data.military} disabled={$user_data.selected_product === null}><option selected={$user_data.military === false} value={false}>No</option><option selected={$user_data.military === true} value={true}>Yes</option></select></div>
        </div>

        <div class="sectionheader">Current Address</div>
        <div class="formrow">
            <div class="formrowlabel">Address</div>
            <div class="formrowinput">
            
            <!-- <input on:keyup={()=>{clearFunction();}} bind:this={address_element} bind:value={$user_data.currentaddress} type="text" /> -->
            
                            <AddressComponent
                            ariaLabel=" "
                            placeholder=" "
                            bind:value={user_address}
                            bind:this={address_element}
                            on:placeChanged={()=>{doSelectAddress();}}
                            styleClass="addresscomponent"
                            apiKey="AIzaSyDJ8ajGxShBN-_cmSsdw-QhNAgN0z1JRaA"/>

            </div>
        </div>
        <div class="multipleformrow">
            <div class="formrow">
                <div class="formrowlabel">Apt/Unit</div>
                <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:value={$user_data.currentaptunit} type="text" /></div>
            </div>
            <div class="formrow">
                <div class="formrowlabel">City or Town</div>
                <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={city_element} bind:value={$user_data.currentcity} type="text" /></div>
            </div>
        </div>
        <div class="multipleformrow">
            <div class="formrow">
                <div class="formrowlabel">Zip code</div>
                <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={zipcode_element} bind:value={$user_data.currentzipcode} type="text" /></div>
            </div>
            <div class="formrow">
                <div class="formrowlabel">State</div>
                <div class="formrowinput"><select  on:change={()=>{clearFunction();}} bind:this={state_element} bind:value={$user_data.currentstate}><option value="AL">Alabama</option><option value="AK">Alaska </option><option value="AZ">Arizona</option><option value="AR">Arkansas   </option><option value="CA">California </option><option value="CO">Colorado   </option><option value="CT">Connecticut</option><option value="DE">Delaware   </option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii </option><option value="ID">Idaho  </option><option value="IL">Illinois   </option><option value="IN">Indiana</option><option value="IA">Iowa   </option><option value="KS">Kansas </option><option value="KY">Kentucky   </option><option value="LA">Louisiana  </option><option value="ME">Maine  </option><option value="MD">Maryland   </option><option value="MA">Massachusetts  </option><option value="MI">Michigan   </option><option value="MN">Minnesota  </option><option value="MS">Mississippi</option><option value="MO">Missouri   </option><option value="MT">Montana</option><option value="NE">Nebraska   </option><option value="NV">Nevada </option><option value="NH">New Hampshire  </option><option value="NJ">New Jersey </option><option value="NM">New Mexico </option><option value="NY">New York   </option><option value="NC">North Carolina </option><option value="ND">North Dakota   </option><option value="OH">Ohio   </option><option value="OK">Oklahoma   </option><option value="OR">Oregon </option><option value="PA">Pennsylvania   </option><option value="RI">Rhode Island   </option><option value="SC">South Carolina </option><option value="SD">South Dakota   </option><option value="TN">Tennessee  </option><option value="TX">Texas  </option><option value="UT">Utah   </option><option value="VT">Vermont</option><option value="VA">Virginia   </option><option value="WA">Washington </option><option value="WV">West Virginia  </option><option value="WI">Wisconsin  </option><option value="WY">Wyoming</option></select></div>
            </div>
        </div>

    </div>
    </Progresscomponent>
</Dtemplate>

<style>
.busybox {
    background-color: white;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    box-sizing: border-box;
}
.busyboxindicatorcontainer {
    margin-bottom: 40px;
}
.busyboxindicatorcontainer img {
    width: 100%;
    /* width: 64px; */
    /* height: 64px; */
}
.progresstextholder {
    width: 100%;
    text-align: center;
    color: var(--placeholdergray);
    font-size: 1.5em;
    /* transition: transform 1s; */
    transition: opacity 1s;
    opacity: 1;

}
.progresstextholder.hidden {
    /* display: none; */
    transition: opacity 1s;
    opacity: 0;
}
.formcontainer {
    margin-top: 40px;
    width: 100%;
    max-width: 550px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}
input, select {
    outline: none;
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box;
    /* height: 100%; */
    padding: 10px;
    border: 1px solid;
    border-color: var(--blueslate);
    -webkit-appearance: none; 
    -moz-appearance: none; 
}
:global(.addresscomponent) {
    outline: none;
    width: 100% !important;
    height: 100% !important;
    box-sizing: border-box;
    /* height: 100%; */
    padding: 10px;
    border: 1px solid;
    border-color: var(--blueslate);
    -webkit-appearance: none; 
    -moz-appearance: none; 
}

select {
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 5px;
}
.titlecontainer {
    color: var(--semperred);
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
    text-align: center;
    font-weight: 700;
    font-size: 2.5em;
    padding-left: 25px;
    padding-right: 25px;
    /* margin-top: 15px; */
}
.copycontainer {
    color: var(--blueslate);
    width: 100%;
    font-size: 1em;
    line-height: 1.5em;
}
.sectionheader {
    margin-top: 60px;
    width: 100%;
    font-size: 1.5em;
    font-weight: 400;
    padding-top: 20px;
    padding-bottom: 10px
}
.formrow {
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}
.formrowlabel {
    color: var(--blueslate);
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 1em;
    text-align: left;
}
.formrowinput {
    max-height: 47px;    
}
.multipleformrow {
    width: 100%;
    padding: 0px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 15px;
    box-sizing: border-box;
  }

  @media (max-device-width: 1024px), (max-width: 1023px) {
    .multipleformrow {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
  }
  
</style>